/**
 * Resolve post-auth redirect path consistently across login and OAuth flows.
 */
export const getPostAuthRedirect = (search: string) => {
  const params = new URLSearchParams(search);

  const redirectAfterLogin =
    localStorage.getItem('redirectAfterLogin') ||
    params.get('redirect') ||
    localStorage.getItem('redirectUrl');

  if (redirectAfterLogin) {
    localStorage.removeItem('redirectAfterLogin');
    localStorage.removeItem('redirectUrl');
    return redirectAfterLogin;
  }

  return '/huong-nghiep-cat?screen=instruction';
};
